import React from 'react';

import './Header.scss';



export default function Header() {
  return (
    <header className="header">
      <div id="header-upper">
        <a href="https://www.cisa.sc.edu/">
          <div className="cisa-logo"><img src={process.env.PUBLIC_URL + '/logos/CISAlogo.svg'} alt="Organization logo for CISA, a NOAA RISA team" /></div>
        </a>
        <a href="https://www.midatlanticrisa.org/">
          <div className="marisa-logo"><img src={process.env.PUBLIC_URL + '/logos/MARISAlogo.svg'} alt="Organization logo for MARISA, a NOAA RISA team" /></div>
        </a>
        <a href="https://glisa.umich.edu/">
          <div className="glisa-logo"><img src={process.env.PUBLIC_URL + '/logos/GLISAlogo.png'} alt="Organization logo for GLISA, a NOAA RISA team" /></div>
        </a>
      </div>

      <div id="header-lower">
        <div id="site-title">Climate and Hazard Mitigation Planning (CHaMP) Tool</div>
      </div>
    </header>
  );
}